export class Result<TValue> {
    value?: TValue;
}